import Link from '@Components/common/Link';
import styled, { css } from 'styled-components';
import { mq, rgba } from 'stylesheets/utils';

export const Section = styled.div`
  background-color: ${({ theme }) => theme.colors.filterCardBg};
  padding: 54px 0 40px 0;
`;

export const Title = styled.h4`
  font-size: ${({ theme }) => theme.fontsizes.h4};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  margin-bottom: 30px;
  text-align: center;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 35px;
  ${mq(576)} {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
export const RelatedList = styled.div`
  display: flex;
  gap: 20px;
  margin: 0 auto 24px;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  min-height: 360px;
  ${mq(992)} {
    overflow-x: auto;
    justify-content: flex-start;
  }
`;
export const Pagination = styled.ul`
  display: flex;
  margin: 0 5px;
  ${mq(576)} {
    margin-bottom: 16px;
  }
`;

export const PaginationNumber = styled.li<{
  readonly active?: boolean;
}>`
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontsizes.body14};
  background-color: ${({ theme }) => theme.colors.pagination.lightenGray};
  color: ${({ theme }) => theme.colors.pagination.lightGray};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  &:first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  ${({ active }) =>
    active
      ? css`
          border-radius: 4px;
          background-color: ${({ theme }) => theme.colors.white};
          color: ${({ theme }) => theme.colors.pagination.black};
          box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
        `
      : css``}
`;

export const PaginationArrow = styled.li<{
  readonly available?: boolean;
}>`
  width: 36px;
  height: 36px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => rgba(theme.colors.pagination.gray, 0.1)};
  border-radius: 4px;
  transform: scale(-1, 1) /*rtl: none */;
  ${({ available }) =>
    available
      ? css`
          background-color: ${({ theme }) => theme.colors.pagination.babyBlue};
        `
      : css``}
  ${mq(576)} {
    margin-bottom: 16px;
  }
`;

export const ShowMoreArrow = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(-1, 1) /*rtl: none */;
  margin-left: 16px;
`;

export const ShowMore = styled(Link)`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.cartCountColor};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  display: flex;
  align-items: center;
  margin-left: auto;
  cursor: pointer;
  ${mq(576)} {
    margin-left: 30px;
  }
`;
export const Arrow = styled.div`
  max-width: 32px;
  min-width: 32px;
  max-height: 36px;
  min-height: 36px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) /*rtl: translateY(-50%) */;
  right: -30px;
  background-color: ${({ theme }) => theme.colors.arrowBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  transform-origin: center center;
  /* transform: scale(-1, 1) ; */
  &.next {
    right: unset;
    left: -30px;
    transform: translateY(-50%) /*rtl: translateY(-50%)  rotate(180deg) */;
  }
  &.prev {
    transform: translateY(-50%) rotate(180deg) /*rtl: translateY(-50%)  rotate(0deg) */;
  }
  ${mq(1200)} {
    right: 0px;
    &.next {
      right: unset;
      left: 0px;
      transform: translateY(-50%) /*rtl: translateY(-50%)  rotate(180deg) */;
    }
  }
  ${mq(768)} {
    right: 10px;
    &.next {
      right: unset;
      left: 10px;
      transform: translateY(-50%) /*rtl: translateY(-50%)  rotate(180deg) */;
    }
  }
`;
